<template lang="pug">
  div
    .input_container
      input(:type="type" @input="returnValue" v-model="value")
      button.delete(@click="clear" :tabindex="-1") ✖
    .error(v-if="error") {{error[0]}}
</template>
<script>
export default {
  props: ['value', 'type', 'error'],
  methods: {
    returnValue () {
      this.$emit('input', this.value)
    },
    clear () {
      this.value = null
      this.$emit('input', this.value)
    }
  }
}
</script>
<style lang="sass" scoped>
.input_container
  display: grid
  grid-template-columns:  auto 50px
input
  border-radius: 4px 0px 0px 4px
  height: 30px
  border: 1px solid #ccc
  font-size: 15px
  color: #212121
  padding-left: 7px
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s
  outline: none
input:focus
  border-radius: 4px 4px 4px 4px
  border-color: rgba(26, 163, 255, 0.8)
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(0, 153, 255, 0.6)
button
  border-radius: 0px 4px 4px 0px
  border: 1px solid #ccc
  border-left: none
  background: white
  display: grid
  align-content: center
  justify-content: center
  cursor: pointer
  outline: none
.delete:hover
  transition: all, .3s
  color: #e2211d
  font-weight: bold
.error
  margin-top: 5px
  font-size: 15px
  color: #e53935
</style>
